import { ROUTES } from '../types/global/routes.types';

export const account_settings_data = [
    {
        name: 'settings',
        route: ROUTES.ACCOUNT_SETTINGS,
    },
    {
        name: 'billing',
        route: ROUTES.ACCOUNT_BILLING,
    },
    {
        name: 'notification',
        route: ROUTES.ACCOUNT_NOTIFICATIONS,
    },
    {
        name: 'subscriptions',
        route: ROUTES.ACCOUNT_SUBSCRIPTION,
    },
    {
        name: 'communications',
        route: ROUTES.ACCOUNT_COMMUNICATIONS,
    },
    {
        name: 'preferences',
        route: ROUTES.ACCOUNT_PREFERENCES,
    },
    {
        name: 'help',
        route: ROUTES.ACCOUNT_HELP,
    },
    {
        name: 'external bank account',
        route: ROUTES.ACCOUNT_EXTERNAL_ACCOUNT,
    },
];
